import React, { useEffect } from "react";
import Layout from "../components/common/Layout/Layout";
import DealerHero from "../components/PageComponents/Hero/DealerHero";
import DealerForm from "../components/PageComponents/Dealer/DealerForm";
import DealerDetail from "../components/PageComponents/Dealer/DealerDetail";
import Products from "../components/PageComponents/Home/Products";
import DealerValues from "../components/PageComponents/Dealer/DealerValues";
import DealerDefault from "../components/PageComponents/Dealer/DealerDefault";

const Dealer = ({
  pageContext: { products, topSkusDefault, dealer, datoDealer },
}) => {
  const topSkus =
    datoDealer && datoDealer.topSkus
      ? datoDealer.topSkus.split("\n")
      : topSkusDefault
      ? topSkusDefault.split("\n")
      : [];

  const topProducts = products.filter((product) =>
    topSkus.includes(product.code)
  );

  useEffect(() => {
    //@ts-ignore
    if (Array.isArray(window.dataLayer) && !!dealer.name) {
      //@ts-ignore
      window.dataLayer.push({
        event: "dealer_website_access",
        storeId: dealer.id,
        dealerName: dealer.name,
      });
    }
  }, [dealer]);

  const dealerName = dealer.name || datoDealer.name;

  return (
    <Layout title={dealerName}>
      <>
        {datoDealer === undefined ||
        !datoDealer.draft ||
        process.env.GATSBY_STAGE === "prod" ? (
          <DealerDefault dealer={dealer} />
        ) : (
          <>
            <DealerHero dealer={dealer} datoDealer={datoDealer} />
            <DealerForm dealer={dealer} datoDealer={datoDealer} />
            <DealerDetail dealer={dealer} datoDealer={datoDealer} />
            {topProducts.length > 0 && <Products products={topProducts} />}
            <DealerValues dealer={dealer} datoDealer={datoDealer} />
          </>
        )}
      </>
    </Layout>
  );
};

export default Dealer;

export function Head({ pageContext: { dealer, datoDealer } }) {
  return (
    <>
      <meta
        name="description"
        content={`${
          dealer.name || datoDealer.name
        } is a licensed Spitwater dealership located in ${dealer.city}, ${
          dealer.state
        }, Australia - see this page for their contact information and further information`}
      />
      <meta
        name="keywords"
        content={`spitwater ${dealer.city}, jetfire ${dealer.city}, vacstorm ${dealer.city}, pressure washer ${dealer.city}`}
      />
    </>
  );
}
